// tslint:disable
import { get } from 'lodash';
import * as React from 'react';
import { IriField } from '../../components/fields/iri.field';
import { FormLib } from '../../components/libs/form.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';
import {IriPresenter} from "../../components/structurals/presenters/iri-presenter";
import {DatepickerField} from "../../components/fields/datepicker.field";

export class DefaultModalUserAccessSubscription extends React.Component<any, any> {
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateEndPoint('user-access-subscription');

        this.executor.updateForm(form);
        await this.executor.exec();
    }

    render() {
        return (
            <ResourceLoader entity="user-access-subscription" entityId={this.props.ENTITY_ID} render={(form: FormLib) => <div>
                <div id="page-title">
                    <h2>Subscription</h2>
                    <p>Lorem</p>
                </div>
                <LoaderComponent isLoading$={this.executor.loading$}/>
                <ToggleBoxComponent title="Subscription details" color="green" alwaysOpen={true}>
                    <div className="row">
                        <div className="col-md-12">


                            <IriField
                                field={form.fields.userAccess}
                                forceQuery={{user: this.props.CONFIG.user, '_deletedAt': null}}
                                itemRender={(item: any) =>
                                    <IriPresenter iri={get(item, 'site.@id')}
                                                  render={(site: any) =>
                                                      get(site, 'name')
                                                  }/>
                                }
                                defaultAll={true}
                            />

                            <DatepickerField
                                field={form.fields.startDate}
                            />

                            <DatepickerField
                                field={form.fields.endDate}
                            />

                            <button className="btn btn-primary pull-left" onClick={() => this.saveForm(form)}>Save</button>
                        </div>
                    </div>
                </ToggleBoxComponent>
            </div>}/>
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/default.modal-user-access-subscription.tsx